import React from "react";
import FileTableIcon from "mdi-material-ui/FileTable";
import { registerOperatorRoute } from "../../../routes";
import ContentViewExtraWideLayout from "../../../layouts/ContentViewExtraWideLayout";
import Reports from "./components/Reports";

registerOperatorRoute({
  isNavigationLink: true,
  isSetting: false,
  priority: 40,
  layoutComponent: ContentViewExtraWideLayout,
  mainComponent: Reports,
  path: "/reports",
  specialAccessId: "reports",
  SidebarIconComponent: (props) => <FileTableIcon {...props} />,
  sidebarI18nLabel: "Reports"
});
